// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"442":"f9cf8763","579":"8404c24b","600":"3b2b3171"}[chunkId] + ".chunk.js";
};